import { LinearProgress, styled, Theme } from "@mui/material";
import { IStyledLinearProgressProps } from "./types";

type LinearProgressColor =
    | "primary"
    | "secondary"
    | "tertiary"
    | "quaternary"
    | "accentInfo"
    | "accentSuccess"
    | "accentWarning"
    | "accentError";

const pickColor = (theme?: Theme): Record<LinearProgressColor, any> => ({
    primary: (theme as any).palette?.primary?.darker,
    secondary: (theme as any).palette?.secondary?.main,
    tertiary: (theme as any).palette?.tertiary?.main,
    quaternary: (theme as any).palette?.tertiary?.light,
    accentInfo: (theme as any).palette?.accentInfo?.main,
    accentSuccess: (theme as any).palette?.accentSuccess?.main,
    accentWarning: (theme as any).palette?.accentWarning?.main,
    accentError: (theme as any).palette?.accentError?.main,
})

const StyledLinearProgress = styled(LinearProgress, {
    shouldForwardProp: prop => prop !== "customColor"
})<IStyledLinearProgressProps>(({ theme, customColor = "primary" }) => ({
    backgroundColor: (theme as any).palette.neutral.darker,
    borderRadius: (theme as any).shape.border.general.radius[4],
    margin: `${theme.spacing(2)} 0px`,
    height: theme.spacing(1),
    "& .MuiLinearProgress-bar": {
        backgroundColor: `${pickColor(theme)[customColor]} !important`,
    }
}))

export { StyledLinearProgress };